import useFeaturePermission from 'src/hooks/useFeaturePermission';
import { AUDIENCE_FEATURE } from './audienceRulesUtils';

/**
 * Single source of truth for "may this user see / edit WhatsApp audience rules".
 *
 * Every audience surface goes through here rather than calling
 * `useFeaturePermission` directly — the templates grid (column, filter, bulk
 * action), the template preview drawer, the Edit WhatsApp Template dialog, the
 * template picker, and the practice-default card in Settings.
 *
 * That indirection is deliberate. The gate previously lived inline in each
 * component, which meant five places to get right and five places to find again
 * whenever it needed changing. One hook means the answer to "who can see this?"
 * has exactly one home.
 *
 * `useFeaturePermission` resolves an unknown or disabled feature to `hidden`,
 * with no bootstrap-permissive fallback — so until a superadmin enables
 * `whatsapp-template-audience` on a practice, every audience surface is absent
 * and none of them issue a request.
 */
export default function useAudiencePermission() {
    return useFeaturePermission(AUDIENCE_FEATURE);
}
